import type {ReactElement} from 'react';
import type {PlayPauseButtonProps} from './play-pause-button.types';
import {DEFAULT_DIAMETER, PROGRESS_RING_BASE_STROKE_WIDTH, PROGRESS_RING_STROKE_WIDTH} from './play-pause-button.types';
import {ClickableDiv} from '@Components/clickable-div';
import {CircularProgressWithChildren} from '@Components/circular-progress-with-children/circular-progress-with-children';
import {Icon} from '@Components/icon-v2';
import {IconShape, IconSize, IconType} from '@Components/icon-v2/icon.types';
import {PMW_COLORS_NEUTRAL, PMW_COLORS_PRIMARY} from '@Utils/color.util';

export function PlayPauseButton(props: PlayPauseButtonProps): ReactElement<HTMLDivElement> {
  const {isPlaying, playbackProgress, diameter = DEFAULT_DIAMETER, baseColor = PMW_COLORS_NEUTRAL.NEUTRAL_1, iconClassName = '', className = ''} = props;

  const getPlayPauseIcon = (): ReactElement => {
    return (
      <Icon
        icon={isPlaying ? 'icon-pause' : 'icon-play-video'}
        size={IconSize.SIZE_ICON_16}
        shape={IconShape.CIRCLE}
        type={IconType.TRANSPARENT}
        isUsedAsButton
        className={`flexbox ${iconClassName}`}
        ariaLabel={isPlaying ? window.i18next.t('pmwjs_pause') : window.i18next.t('pmwjs_play')}
      />
    );
  };

  const getButtonContent = (): ReactElement => {
    if (!isPlaying) {
      return getPlayPauseIcon();
    }

    return (
      <CircularProgressWithChildren
        strokeWidth={PROGRESS_RING_STROKE_WIDTH}
        baseStrokeWidth={PROGRESS_RING_BASE_STROKE_WIDTH}
        diameter={diameter}
        baseColor={baseColor}
        fillColor={PMW_COLORS_PRIMARY.PRIMARY_100}
        value={playbackProgress}
      >
        {getPlayPauseIcon()}
      </CircularProgressWithChildren>
    );
  };

  return (
    <ClickableDiv
      className={`flex-center radius-round ${className}`}
      onClick={(e) => {
        props.onClick(e);
      }}
    >
      {getButtonContent()}
    </ClickableDiv>
  );
}
